// NOTICE! works till 4.10.1 version because of https://github.com/ReactTraining/history/issues/804
import { createBrowserHistory } from 'history';

export default createBrowserHistory();
